var _g, _g2, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconClock = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12931_8103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12931_8103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 3.42808C15.2049 1.57877 12.6364 0.5 9.99937 0.5C8.03019 0.5 6.09526 1.08219 4.4343 2.17808C2.80759 3.27397 1.54047 4.83219 0.769919 6.68151C-0.000629421 8.5137 -0.188986 10.5 0.187727 12.4521C0.581562 14.4041 1.52334 16.1678 2.92745 17.5719C4.33156 18.976 6.09526 19.9178 8.04732 20.2945C8.698 20.4315 9.34869 20.4829 9.99937 20.4829C11.3007 20.4829 12.6021 20.226 13.8179 19.7123C15.6501 18.9589 17.2083 17.6747 18.3042 16.0308C19.4001 14.387 19.9822 12.4521 19.9822 10.4658C19.9822 7.82877 18.9206 5.24315 17.0542 3.39384V3.42808ZM17.8932 10.5C17.8932 12.6062 17.0713 14.5925 15.5816 16.0822C14.109 17.5548 12.0884 18.3938 9.99937 18.3938C8.42403 18.3938 6.90006 17.9315 5.61581 17.0582C4.31444 16.1849 3.30417 14.9692 2.70485 13.5308C2.10554 12.0925 1.95143 10.5171 2.25964 8.97603C2.56786 7.43493 3.32129 6.04794 4.41718 4.93493C5.51307 3.82192 6.91718 3.08562 8.45827 2.7774C8.97197 2.67466 9.48567 2.62329 10.0165 2.62329C11.0439 2.62329 12.0713 2.82877 13.0302 3.2226C14.4685 3.82192 15.6843 4.83219 16.5576 6.13356C17.4309 7.43493 17.8932 8.9589 17.8932 10.5171V10.5Z",
    fill: "#5849A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.363 10.0033H11.0788C11.0959 7.36632 11.0617 9.31837 11.0617 6.45878C11.0617 6.11632 10.9418 5.8081 10.7021 5.55125C10.5137 5.36289 10.2911 5.24303 10.0343 5.17454C9.79453 5.12317 9.52056 5.14029 9.26371 5.24303C9.02399 5.32864 8.85275 5.49988 8.69864 5.70536C8.56166 5.91084 8.49316 6.15056 8.49316 6.39029C8.49316 9.60947 8.49316 7.99988 8.49316 11.2875C8.49316 11.5958 8.61303 11.9211 8.83563 12.1608C9.05823 12.3834 9.34933 12.5375 9.69179 12.5718H12.1575C12.5 12.5889 12.8425 12.5033 13.0822 12.2636C13.3391 12.041 13.5103 11.7499 13.5274 11.3732C13.5445 11.0307 13.4589 10.6882 13.2192 10.4485C12.9966 10.1917 12.7055 10.0204 12.3288 10.0033H12.363Z",
    fill: "#5849A6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12931_8103)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#5849A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12931_8103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconClock.7186ade1.svg";
export { ForwardRef as ReactComponent };